import {
    chatProjection,
    createSceneProjection,
    localPlayerProjection,
    playerProjection,
    useGameStore,
    usePixiRenderOnStoreChange,
} from '@glark-newco/game-library';
import {useEffect} from 'react';
import {gameTimerProjection} from './GameTimerSlice';
import {networkEditStore} from './networkEditStore';
import {networkProjection} from './networkSlice';
import {networkStore} from './networkStore';
import {playerActivityProjection} from './PlayerActivitySlice';
import {avatarProjection} from './PlayerAvatarSlice';
import {objectivesProjection} from './PlayerObjectivesSlice';
import {playerRingsProjection} from './PlayerRingsSlice';
import {ringDefinitionsProjection} from './RingDefinitionsSlice';
import {ringStatisticsProjection} from './RingStatisticsSlice';
import {ringTransferListenerProjection} from './RingTransferListenerSlice';
import {spareRopeProjection} from './spareRopeSlice';
import {uiStore} from './uiStore';
import {SupplyChainSceneMutator} from '../components/SupplyChainSceneMutator';

export const SupplyChainProjections = () => {
    const register = useGameStore(s => s.registerProjection);
    const reset = useGameStore(s => s.reset);

    usePixiRenderOnStoreChange(networkStore);
    usePixiRenderOnStoreChange(networkEditStore);
    usePixiRenderOnStoreChange(uiStore);

    useEffect(() => {
        register(playerProjection);
        register(localPlayerProjection);
        register(chatProjection);
        register(createSceneProjection(SupplyChainSceneMutator));

        register(avatarProjection);
        register(gameTimerProjection);
        register(networkProjection);
        register(objectivesProjection);
        register(playerRingsProjection);
        register(playerActivityProjection);
        register(ringDefinitionsProjection);
        register(ringStatisticsProjection);
        register(ringTransferListenerProjection);
        register(spareRopeProjection);

        return () => reset();
    }, [register]);

    return null; // nothing rendered
};
